import PriceTagIconPath from "@ingka/ssr-icon/paths/price-tag";

export default PriceTagIconPath;
